<template>
  <div id="page-user-edit">
    <vx-card v-if="operation_data">
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <div class="tab-text">
          <template>
            <div id="user-edit-tab-info">
              <!-- In SAGA (SagaX2n, or the old robot): the API refuses to change what SAGA holds (api/app/helpers/sagaLock.js). -->
              <vs-alert v-if="operation_data.issyncsaga === true" color="warning" active="true" icon-pack="feather" icon="icon-lock" class="mt-4 mb-2">
                This production is in SAGA<template v-if="operation_data.saga_sent_at"> since {{ new Date(operation_data.saga_sent_at).toLocaleDateString('en-GB', { timeZone: 'Europe/Bucharest' }) }}</template>:
                its date, name and lines can no longer be changed here. To change them, delete it in SAGA, then release it in Settings → Dependency Sync.
              </vs-alert>
              <!-- Content Row -->
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full">
                  <!--
                  <vs-input
                    class="w-full mt-4"
                    label="Operation Category"
                    v-model="operation_data.operationcategory.name_en"
                    disabled
                  />
                  <br />-->
                  <vx-input-group class="mb-base">
                    <template slot="prepend">
                      <div class="prepend-text bg-primary">
                        <span>Internal ID #</span>
                      </div>
                    </template>
                    <vs-input v-model="operation_data.id" disabled size="default" />
                  </vx-input-group>
                  <div class="w-full mt-0">
                  <vs-input label="Weight (t)" v-model="operation_data.transport_tonaj" v-validate="'decimal'"
                          class="w-full" name="weight" />
                        <span class="text-danger text-sm" v-show="errors.has('weight')">{{
                          errors.first("weight")
                        }}</span>
                  </div>
                  <p class="w-full mt-4" style="font-size:85%">
                    &nbsp;Operation Date
                    <datepicker :inline="false" v-model="operation_data.date" :disabled="sagaLocked"></datepicker>
                  </p>
                </div>
              </div>
              <br />
              <br />
              <template>
                <div id="data-list-list-view" class="data-list-container">
                  <data-view-sidebar
                    :isSidebarActive="addNewDataSidebar"
                    @closeSidebar="toggleDataSidebar"
                    :data="sidebarData"
                  />

                  <vs-table ref="table" :data="products">
                    <div
                      slot="header"
                      class="flex flex-wrap-reverse items-center flex-grow justify-between"
                    >
                      <div class="flex flex-wrap-reverse items-center data-list-btn-container">
                        <!-- ACTION - DROPDOWN -->

                        <!-- ADD NEW -->
                        <div v-if="!sagaLocked" class="mt-4 mb-4 flex flex-wrap items-center justify-end">
                          <vs-button
                            class="ml-auto"
                            color="danger"
                            icon-pack="feather"
                            icon="icon-plus"
                            @click="addNewData(1)"
                          >Product Out</vs-button>&nbsp;&nbsp;
                          <vs-button
                            class="ml-auto"
                            color="primary"
                            icon-pack="feather"
                            icon="icon-plus"
                            @click="addNewData(2)"
                          >Product In</vs-button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          <vs-button
                            class="ml-auto"
                            v-if="this.$store.state.operationList.m3difference != 0"
                            color="#8cb3d9"
                            icon-pack="feather"
                            icon="icon-plus"
                            @click="addNewData(3)"
                            style="float:right"
                          >Adjust difference ({{ Number(Math.abs(this.$store.state.operationList.m3difference)).toFixed(4)}}) m3</vs-button>
                        </div>
                      </div>
                    </div>

                    <template slot="thead">
                      <vs-th>Type</vs-th>
                      <vs-th>#</vs-th>
                      <vs-th>Category Product</vs-th>
                      <vs-th>Name</vs-th>
                      <vs-th>Quantity</vs-th>
                      <vs-th>Uom</vs-th>
                      <vs-th>Volume / Uom</vs-th>
                      <vs-th>Volume Total</vs-th>
                      <vs-th>Action</vs-th>
                    </template>

                    <template slot-scope="{data}">
                      <tbody>
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                          <vs-td v-if="tr.operations_products.quantity >= 0">
                            <vs-chip color="green">
                              <p class="font-medium truncate">STOCK IN</p>
                            </vs-chip>
                          </vs-td>
                          <vs-td v-else>
                            <vs-chip color="red">
                              <p class="font-medium truncate">STOCK OUT</p>
                            </vs-chip>
                          </vs-td>

                          <vs-td>
                            <p class="font-medium truncate">{{ indextr+1 }}</p>
                          </vs-td>

                          <vs-td>
                            <p class="font-medium truncate">{{ tr.productcategory.name_en }}</p>
                          </vs-td>

                          <vs-td>
                            <p>{{ tr.name_en }}</p>
                          </vs-td>

                          <vs-td>
                            <p>{{ parseFloat(tr.operations_products.quantity).toFixed(4) }}</p>
                          </vs-td>

                          <vs-td>{{ tr.uomsreference.name_en }}</vs-td>

                          <vs-td>
                            <p>{{ parseFloat(tr.volume).toFixed(4) }}</p>
                          </vs-td>
                          <vs-td>
                            <p>{{ parseFloat(tr.volume * tr.operations_products.quantity).toFixed(4) }}</p>
                          </vs-td>

                          <vs-td class="whitespace-no-wrap">
                            <template v-if="!sagaLocked">
                            <feather-icon
                              icon="EditIcon"
                              svgClasses="w-5 h-5 hover:text-primary stroke-current"
                              @click.stop="editData(tr)"
                            />
                            <feather-icon
                              icon="TrashIcon"
                              svgClasses="w-5 h-5 hover:text-danger stroke-current"
                              class="ml-2"
                              @click.stop="deleteProduct(tr.id,tr.name)"
                            />
                            </template>
                          </vs-td>
                        </vs-tr>
                      </tbody>
                    </template>
                  </vs-table>
                </div>
              </template>
              <!-- Save & Reset Button -->
              <div class="vx-row">
                <div class="vx-col w-full">
                  <div class="mt-8 flex flex-wrap items-center justify-end">
                    <vs-button
                      v-if="operation_data.isactive"
                      type="border"
                      color="danger"
                      icon-pack="feather"
                      icon="icon-trash"
                      :disabled="sagaLocked"
                      @click="confirmDeleteRecord"
                    >Disable Operation</vs-button>
                    <vs-button
                      v-else
                      type="border"
                      color="primary"
                      icon-pack="feather"
                      icon="icon-trash"
                      @click="confirmEnableRecord"
                    >Enable</vs-button>
                    <vs-button
                      class="ml-auto"
                      color="primary"
                      @click="save_changes"
                      :disabled="!validateForm"
                    >Save Changes</vs-button>
                  </div>
                  <br />
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import DataViewSidebar from "./DataViewSidebar.vue";
import vSelect from "vue-select";
import axios from "@/axios.js";
import Datepicker from "vuejs-datepicker";
import moduleOperationList from "@/store/operation/moduleOperationList.js";
import moment from "moment";

export default {
  components: {
    DataViewSidebar,
    vSelect,
    Datepicker
  },
  data() {
    return {
      operation_data: null,
      product_data: null,
      data_option_people_name: [],
      //operation_data: JSON.parse(JSON.stringify(this.data)),
      selected: [],
      //itemsPerPage: 1000,
      isMounted: false,
      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      buttonSubmitOpen: false,
      state: {},
      producttodelete: null,
      maxdateoperation: ""
    };
  },
  computed: {
    // Dans SAGA (SagaX2n, ou l'ancien SagaX2) : date, lignes et désactivation ne
    // se modifient plus ici. L'API le refuse aussi (api/app/helpers/sagaLock.js).
    sagaLocked() {
      return !!(this.operation_data && this.operation_data.issyncsaga === true);
    },
    products() {
      return this.$store.state.operationList.operationproducts;
    },
    validateForm() {
      return !this.errors.any();
    },
    currentPage() {
      if (this.isMounted) {
        if (this.operation_data.id) return this.$refs.table.currentx;
      }
      return 0;
    },
    queriedItems() {
      if (this.operation_data.id)
        return this.$refs.table
          ? this.$refs.table.queriedResults.length
          : this.users.length;
    }
  },
  methods: {
    confirmDeleteRecord() {
      let namealert =
        this.operation_data.operationcategory.name_en +
        " #" +
        this.operation_data.id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm Disable",
        text: `You are about to disable ${namealert}`,
        accept: this.deleteRecord,
        acceptText: "Disable"
      });
    },
    confirmEnableRecord() {
      let namealert =
        this.operation_data.operationcategory.name_en +
        " #" +
        this.operation_data.id;
      this.$vs.dialog({
        type: "confirm",
        color: "success",
        title: "Confirm Enable",
        text: `You are about to re-enable ${namealert}`,
        accept: this.enableRecord,
        acceptText: "Enable"
      });
    },
    enableRecord() {
      axios
        .post("/operation/enable", { id: this.operation_data.id })
        .catch((err) => {
          this.showActionFailed(err);
        });
      this.$router.push({ path: "/production/" + this.operation_data.id });
      this.showEnableSuccess();
    },
    // Les .catch vides (et les `reject(error)` sur un identifiant inexistant)
    // masquaient tout echec : l'ecran annoncait le succes quand meme.
    showActionFailed(err) {
      console.error("operation enable/disable:", err);
      const data = err && err.response && err.response.data;
      this.$vs.notify({
        color: "danger",
        title: "Action NOT applied",
        text: (data && (data.message || data.error)) || (err && err.message) ||
          "The server refused the operation. Reload the page to see its real state.",
        time: 12000,
      });
    },
    showEnableSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Operation Enable",
        text: "The selected operation was successfully enabled"
      });
    },
    deleteRecord() {
      axios
        .post("/operation/disable", { id: this.operation_data.id })
        .catch((err) => {
          this.showActionFailed(err);
        });
      this.$router.push({ path: "/production/" + this.operation_data.id });
      this.showDeleteSuccess();
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Operation Deleted",
        text: "The selected operation was successfully deleted"
      });
    },
    capitalize(str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length);
    },
    addNewData(type) {
      //type 1 = out , 2 = in, 3 = adjustment
      if (this.operation_data.id) {
        var idoperation = this.operation_data.id;
        var idcategoryoperation = this.operation_data.operationcategory.id;
        var isconsumption = false;
        var valeuradj = 0;
        if (type === 1) isconsumption = true;
        else if (type === 2) isconsumption = false;
        else if (type === 3) {
          isconsumption = false;
          valeuradj = this.$store.state.operationList.m3difference;
        }
        this.sidebarData = {
          idoperation,
          idcategoryoperation,
          isconsumption,
          valeuradj
        };
        this.toggleDataSidebar(true);
      } else {
        this.$vs.notify({
          color: "alert",
          title: "Alert!",
          text: "Please select a Person before!"
        });
      }
    },
    getMaxInventoryDate() {
      var dateStop = moment(this.dataDate)
        .add(12, "hours")
        .format("YYYY-MM-DD");
      axios.get("/getmaxinventorydate").then(response => {
        this.maxdateoperation = response.data;
      });
    },
    save_changes() {
      if (parseFloat(this.operation_data.transport_tonaj) > 99.0) 
      {

        this.$vs.notify({
          color: "warning",
          title: "Weight > 99 tons",
          text: "The weight is in tons!"
        });
        return;
      }
      /*if (
        moment(this.maxdateoperation).add(12, "hours") >=
        moment(this.operation_data.date)
      ) {
        this.$vs.notify({
          color: "danger",
          title: "Wrong Date!",
          text:
            "You cannot edit Production after an Inventory (Inventory date : " +
            this.maxdateoperation +
            ")"
        });
        return;
      }*/
      /* eslint-disable */
      const obj = {
        id: this.operation_data.id,
        transport_tonaj: this.operation_data.transport_tonaj,
        date: moment(this.operation_data.date)
      };
      if (this.operation_data.id) {
        // Attendre la réponse : un refus (409 « in SAGA », api/app/helpers/sagaLock.js)
        // ne doit plus s'afficher comme « Operation Updated! ».
        this.$store
          .dispatch("operationList/updateOperation", obj)
          .then(() => {
            this.$router.push({
              path: "/production/" + this.operation_data.id
            });
            this.$vs.notify({
              color: "success",
              title: "Operation Updated!",
              text: "The operation was successfully updated"
            });
          })
          .catch(err => {
            console.error(err);
            this.$vs.notify({
              color: "danger",
              title: "Save failed",
              text: (err && err.response && err.response.data && err.response.data.message) || "The operation was NOT saved."
            });
          });
      }
    },
    showDeleteAddressSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Product Deleted",
        text: "The Product was successfully deleted"
      });
    },
    deleteProductOne() {
      /*alert("idaddress"+this.addresstodelete)
      alert("idperson"+this.operation_data.id)*/
      const obj = {
        idproduct: this.producttodelete,
        idoperation: this.operation_data.id
      };
      if (!moduleOperationList.isRegistered) {
        this.$store.registerModule("operationList", moduleOperationList);
        moduleOperationList.isRegistered = true;
      }
      this.$store.dispatch("operationList/removeItem", obj).catch(err => {
        console.error(err);
      });
      //refresh view after delete

      this.$store
        .dispatch("operationList/fetchm3difference", this.$route.params.userId)
        .then(res => {})
        .catch(err => {
          if (err.response.status === 404) {
            this.user_not_found = true;
            return;
          }
          console.error(err);
        });
      this.showDeleteAddressSuccess();
    },
    deleteProduct(id, name) {
      this.producttodelete = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm Delete",
        text: `You are about to delete the product ${name}`,
        accept: this.deleteProductOne,
        acceptText: "Delete Product"
      });
    },
    editData(data) {
      data.idperson = this.operation_data.id;
      data.idcategoryoperation = this.operation_data.operationcategory.id;
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    getActiveColors(status) {
      if (status === "true") return "primary";
      if (status === false) return "danger";
      return "warning";
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    redirection() {
      if (this.user_data.operationcategory.id === 3) {
        //
      } else {
        this.$router.push({ path: "/pages/error-404" });
      }
    },
    fetch_operation_data(userId) {
      if (userId) {
        this.$store
          .dispatch("operationList/fetchOperation", userId)
          .then(res => {
            this.operation_data = res.data;
            this.getPeople();
            this.redirection();
          })
          .catch(err => {
            if (err.response.status === 404) {
              this.user_not_found = true;
              return;
            }
            console.error(err);
          });
      } else {
        this.operation_data = {};
      }
    },
    fetch_product_data(userId) {
      if (userId) {
        this.$store.dispatch("operationList/fetchOperationProducts", userId);
      } else {
        this.product_data = {};
      }
    }
  },

  created() {
    if (!moduleOperationList.isRegistered) {
      this.$store.registerModule("operationList", moduleOperationList);
      moduleOperationList.isRegistered = true;
    }
    this.fetch_operation_data(this.$route.params.userId);
    this.fetch_product_data(this.$route.params.userId);
    //this.getInOutDifference();
    this.getMaxInventoryDate();

    this.$store
      .dispatch("operationList/fetchm3difference", this.$route.params.userId)
      .then(res => {
        //this.m3difference = res;
        //console.log(this.$store.state.operationList.m3difference)
      })
      .catch(err => {
        if (err.response.status === 404) {
          this.user_not_found = true;
          return;
        }
        console.error(err);
      });
  },
  mounted() {
    this.isMounted = true;
  }
};
</script>

